const CITIES = [
  {
    slug: "austin",
    city: "Austin",
    intro: "Austin's real estate market moves fast. Your listing descriptions should too. ListWorks PRO rewrites boring MLS drafts into copy that sells — in 10 seconds, with Fair Housing compliance built in.",
    why_matters: "Austin agents compete with thousands of listings. Generic descriptions get ignored. ListWorks helps you stand out with lifestyle-driven copy that actually reflects Austin's unique market.",
    local_market: "Austin's median home price is $550K+ with inventory climbing. Buyers here are tech-savvy and scroll past anything that sounds templated. Your copy needs to hit different.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste any MLS draft, pick a tone, get publish-ready copy instantly." },
      { title: "5 Output Formats", desc: "MLS description, Instagram caption, Facebook post, headlines, and email — all from one input." },
      { title: "Fair Housing Guard", desc: "Automatic compliance scanning catches discriminatory language before you publish." },
      { title: "Local Gems", desc: "Pull schools, restaurants, and neighborhood data into your listing automatically." },
    ],
  },
  {
    slug: "miami",
    city: "Miami",
    intro: "Miami real estate is all about lifestyle. Your listing copy needs to capture the energy, the views, and the investment. ListWorks rewrites your MLS drafts into copy that converts.",
    why_matters: "Miami's luxury market demands exceptional copy. Buyers are international, discerning, and looking at dozens of listings. Yours needs to stop the scroll.",
    local_market: "Miami-Dade has 20K+ active listings. From Brickell condos to Coral Gables estates, each property needs distinct copy. Generic won't work.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste any MLS draft, pick a tone, get publish-ready copy instantly." },
      { title: "5 Output Formats", desc: "MLS description, Instagram caption, Facebook post, headlines, and email — all from one input." },
      { title: "Bilingual Ready", desc: "Generate listings in English or Spanish with one click." },
      { title: "Multilingual Output", desc: "Perfect for Miami's diverse buyer pool — generate in Spanish, Chinese, or English." },
    ],
  },
  {
    slug: "denver",
    city: "Denver",
    intro: "Denver's competitive market demands listing copy that works as hard as the agents. ListWorks PRO rewrites boring MLS drafts into copy that sells — fast.",
    why_matters: "Denver agents are juggling a hot market with tight inventory. Every listing needs to maximize attention in the shortest window possible.",
    local_market: "Denver metro saw 5,000+ new listings last month. Stand out with copy that highlights outdoor access, school districts, and neighborhood character.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste any MLS draft, pick a tone, get publish-ready copy instantly." },
      { title: "5 Output Formats", desc: "MLS, Instagram, Facebook, headlines, and email from one input." },
      { title: "Local Gems Integration", desc: "Auto-pull data on parks, transit, schools, and restaurants." },
    ],
  },
  {
    slug: "dallas",
    city: "Dallas",
    intro: "DFW is one of the fastest-growing metros in the country. Stay ahead of the wave with AI-powered listing copy that sells.",
    why_matters: "With 10,000+ people moving to DFW monthly, agents need to move fast. Generic copy costs you showings.",
    local_market: "From Uptown condos to Frisco family homes, Dallas real estate is diverse. Your copy should match the neighborhood.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste, pick a tone, get publish-ready copy instantly." },
      { title: "5 Output Formats", desc: "MLS, social, email, and headlines from one draft." },
      { title: "MLS Character Presets", desc: "Auto-format for local MLS rules and character limits." },
    ],
  },
  {
    slug: "los-angeles",
    city: "Los Angeles",
    intro: "LA real estate lives and dies on curb appeal — and that includes your copy. ListWorks rewrites drafts into listings that sell.",
    why_matters: "LA buyers see hundreds of listings. Yours needs to stop the scroll in under 3 seconds.",
    local_market: "From Silver Lake to Santa Monica, every neighborhood has a different vibe. Your copy should match it.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste, pick a tone, get publish-ready copy." },
      { title: "Luxury Tone Options", desc: "Multiple writing styles from Modern to Luxury to Minimalist." },
      { title: "Fair Housing Compliance", desc: "Automatic scanning protects you from HUD violations." },
    ],
  },
  {
    slug: "new-york",
    city: "New York",
    intro: "NYC real estate is a different beast. ListWorks helps you write listings that capture the energy of every borough.",
    why_matters: "New York buyers have seen it all. Your copy needs to feel fresh, specific, and not like every other listing.",
    local_market: "From Manhattan co-ops to Brooklyn townhouses, NYC real estate demands precision copywriting.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste, pick a tone, get publish-ready copy instantly." },
      { title: "5 Output Formats", desc: "MLS, Instagram, Facebook, headlines, and email from one draft." },
      { title: "MLS Character Presets", desc: "Auto-format for NYC-area MLS rules." },
    ],
  },
  {
    slug: "nashville",
    city: "Nashville",
    intro: "Nashville's boom isn't slowing down. Keep up with AI listing copy that matches the energy of Music City.",
    why_matters: "Nashville gained 100+ new residents daily in 2025. Agents need to move fast with listings that convert.",
    local_market: "From East Nashville bungalows to Brentwood estates, Music City's market is white-hot.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste any MLS draft, get publish-ready copy." },
      { title: "5 Output Formats", desc: "MLS, social, email, and headlines from one input." },
    ],
  },
  {
    slug: "phoenix",
    city: "Phoenix",
    intro: "Phoenix is one of the fastest-growing cities in America. ListWorks helps agents write listings that sell in a competitive market.",
    why_matters: "Phoenix inventory is rising and buyers have options. Great copy is what separates a quick sale from a 60-day listing.",
    local_market: "From Scottsdale luxury to suburban family homes, Phoenix real estate is all about location and lifestyle.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste any MLS draft, pick a tone, get publish-ready copy." },
      { title: "5 Output Formats", desc: "MLS description, Instagram, Facebook, headlines, and email." },
    ],
  },
  {
    slug: "chicago",
    city: "Chicago",
    intro: "Chicago real estate is diverse — from lakefront condos to suburban family homes. ListWorks writes copy that matches every neighborhood.",
    why_matters: "Chicago agents deal with hyper-local markets. Lincoln Park buyers want different copy than Wicker Park buyers.",
    local_market: "Chicago's 200+ neighborhoods each have a distinct character. Your listing copy should reflect that.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste, pick a tone, get publish-ready copy." },
      { title: "Neighborhood-Aware Copy", desc: "Local Gems pulls schools, transit, and restaurant data." },
    ],
  },
  {
    slug: "seattle",
    city: "Seattle",
    intro: "Seattle's competitive market demands precision. ListWorks rewrites MLS drafts into copy that actually sells.",
    why_matters: "Seattle buyers are informed and particular. Generic descriptions don't cut it.",
    local_market: "From Capitol Hill to Bellevue, Seattle real estate requires local knowledge in every word.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste any MLS draft, get publish-ready copy." },
      { title: "5 Output Formats", desc: "MLS, Instagram, Facebook, headlines, and email." },
    ],
  },
  {
    slug: "san-diego",
    city: "San Diego",
    intro: "San Diego's real estate market is all about location and lifestyle. ListWorks helps you capture both in every listing.",
    why_matters: "SD inventory is tight and buyers are serious. Your copy needs to match the quality of the properties.",
    local_market: "From coastal luxury to inland family homes, San Diego has it all. Your copy should too.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste any MLS draft, get publish-ready copy." },
      { title: "5 Output Formats", desc: "MLS, social, email, and headlines from one draft." },
    ],
  },
  {
    slug: "orlando",
    city: "Orlando",
    intro: "Orlando's market is booming with new residents daily. ListWorks helps agents write listings that sell fast.",
    why_matters: "Central Florida is attracting buyers from across the country. Your listing copy needs to speak to newcomers.",
    local_market: "From downtown condos to suburban family homes, Orlando real estate is diverse and growing.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste any MLS draft, get publish-ready copy." },
      { title: "5 Output Formats", desc: "MLS, Instagram, Facebook, headlines, and email." },
    ],
  },
  {
    slug: "houston",
    city: "Houston",
    intro: "Houston's massive market demands efficiency. ListWorks rewrites MLS drafts into selling copy in 10 seconds.",
    why_matters: "With 30K+ active listings, Houston agents need every advantage. Great copy is the differentiator.",
    local_market: "From The Heights to Sugar Land, Houston's neighborhoods each have a distinct personality.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste, pick a tone, get publish-ready copy." },
      { title: "5 Output Formats", desc: "MLS, social, email, and headlines." },
      { title: "MLS Presets", desc: "Auto-format for local MLS systems." },
    ],
  },
  {
    slug: "atlanta",
    city: "Atlanta",
    intro: "Atlanta's market is one of the hottest in the country. ListWorks helps agents write listings that sell above asking.",
    why_matters: "Atlanta agents compete in a fast-moving market. Speed and quality of copy make the difference.",
    local_market: "From Buckhead luxury to intown bungalows, Atlanta real estate rewards specific, local copy.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste any MLS draft, get publish-ready copy." },
      { title: "5 Output Formats", desc: "MLS, Instagram, Facebook, headlines, email." },
    ],
  },
  {
    slug: "portland",
    city: "Portland",
    intro: "Portland buyers value authenticity. ListWorks writes listing copy that feels real, not templated.",
    why_matters: "Portland's market rewards specific, personality-driven copy. Generic AI output gets ignored.",
    local_market: "From Alberta Arts to the West Hills, Portland's neighborhoods each have a distinct culture.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste any MLS draft, pick a tone, get copy." },
      { title: "Anti-AI Tone Control", desc: "Banned cliché words removed automatically." },
    ],
  },
  {
    slug: "tampa",
    city: "Tampa",
    intro: "Tampa Bay is one of the fastest-growing metros in Florida. ListWorks helps you keep up with demand.",
    why_matters: "Tampa inventory moves fast when marketed right. Your listing copy should sell the lifestyle.",
    local_market: "From waterfront luxury to suburban family communities, Tampa real estate is booming.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste any MLS draft, get publish-ready copy." },
      { title: "5 Output Formats", desc: "MLS, Instagram, Facebook, headlines, email." },
    ],
  },
  {
    slug: "charlotte",
    city: "Charlotte",
    intro: "Charlotte is one of the fastest-growing cities in the US. ListWorks helps local agents write listings that sell.",
    why_matters: "Charlotte's market is attracting buyers from across the country. Your copy needs to speak to newcomers.",
    local_market: "From South End condos to Lake Norman waterfront, Charlotte real estate is diverse and growing.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste, pick a tone, get publish-ready copy." },
      { title: "5 Output Formats", desc: "MLS, social, email, and headlines." },
    ],
  },
  {
    slug: "san-antonio",
    city: "San Antonio",
    intro: "San Antonio's market is thriving. ListWorks helps agents write compelling listing copy in seconds.",
    why_matters: "San Antonio buyers appreciate authenticity. Generic copy won't stand out in this growing market.",
    local_market: "From historic King William to master-planned communities, SA real estate rewards local knowledge.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste any MLS draft, get publish-ready copy." },
      { title: "5 Output Formats", desc: "MLS, Instagram, Facebook, headlines, email." },
    ],
  },
  {
    slug: "las-vegas",
    city: "Las Vegas",
    intro: "Las Vegas real estate is booming with new residents. ListWorks helps agents write listings that convert.",
    why_matters: "Vegas buyers come from everywhere. Your copy needs to sell the lifestyle and the investment.",
    local_market: "From the Strip-adjacent condos to Summerlin family homes, Vegas has diverse buyer pools.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste any MLS draft, get publish-ready copy." },
      { title: "5 Output Formats", desc: "MLS, social, email, and headlines." },
    ],
  },
  {
    slug: "raleigh",
    city: "Raleigh",
    intro: "Raleigh is one of America's fastest-growing cities. ListWorks helps local agents write listing copy that keeps up.",
    why_matters: "Raleigh's market attracts educated, discerning buyers. Your copy needs to match the quality.",
    local_market: "From downtown condos to suburban family neighborhoods, the Triangle has diverse buyers.",
    features: [
      { title: "10-Second Rewrites", desc: "Paste any MLS draft, get publish-ready copy." },
      { title: "5 Output Formats", desc: "MLS, Instagram, Facebook, headlines, email." },
    ],
  },
  // --- Colorado ---
  {
    slug: "colorado-springs",
    city: "Colorado Springs",
    intro: "Colorado Springs agents know Fair Housing compliance isn't optional. ListWorks PRO screens every rewrite for discriminatory language before it reaches the MLS.",
    why_matters: "Fair Housing is strict liability — intent doesn't matter. HUD fines start at $26,262 for first violations. Automated compliance checking is your best defense.",
    local_market: "Colorado Springs is one of Colorado's fastest-growing markets with 8,000+ active agents. Military relocation demand from Fort Carson and Peterson keeps inventory moving year-round.",
    features: [
      { title: "Fair Housing Guard", desc: "Catch discriminatory language before you post — the $26,262 fine is real." },
      { title: "10-Second Rewrites", desc: "Paste any MLS draft, pick a tone, get publish-ready copy." },
      { title: "5 Output Formats", desc: "MLS, Instagram, Facebook, headlines, and buyer email from one input." },
      { title: "AI Disclosure", desc: "Recommended best practice — add AI disclosure to listings with one click." },
    ],
  },
  {
    slug: "boulder",
    city: "Boulder",
    intro: "Boulder's median price tops $900K. Buyers here are educated, skeptical, and demand authentic copy. ListWorks PRO gives you that edge — with built-in Fair Housing compliance screening.",
    why_matters: "Boulder agents face a uniquely discerning buyer pool. Tech industry relocations, CU proximity, and outdoor lifestyle demand copy that speaks to each buyer segment without clichés.",
    local_market: "Boulder inventory is chronically tight with 500-700 active listings at any time. Every listing gets multiple showings — your copy is the first impression that earns them.",
    features: [
      { title: "Fair Housing Guard", desc: "Compliance screening on every output — $26,262 HUD fines are real." },
      { title: "Anti-Cliché Guard", desc: "'Stunning,' 'nestled,' and 'charming' are banned at the system level. Every rewrite." },
      { title: "Lifestyle Copy Engine", desc: "Auto-generates outdoor lifestyle, walkability, and university proximity angles." },
      { title: "10-Second Rewrites", desc: "From draft to publish-ready in under 10 seconds." },
    ],
  },
  {
    slug: "fort-collins",
    city: "Fort Collins",
    intro: "Fort Collins is Colorado's fastest-growing city outside Denver. ListWorks PRO helps agents keep up with AI-generated listing copy and Fair Housing compliance built in.",
    why_matters: "Northern Colorado is booming. Fort Collins, Loveland, and Greeley agents are competing for the same buyers fleeing Denver prices. Your copy needs to differentiate every listing.",
    local_market: "Fort Collins has 1,200+ active listings with average DOM under 20 days. The CSU influence brings strong rental and first-time buyer demand in specific neighborhoods.",
    features: [
      { title: "Fair Housing Guard", desc: "Catch discriminatory language automatically on every rewrite." },
      { title: "10-Second Rewrites", desc: "Paste, pick a tone, get copy." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines from one input." },
      { title: "AI Disclosure", desc: "Recommended best practice — add to any listing in one click." },
    ],
  },
  {
    slug: "aurora",
    city: "Aurora",
    intro: "Aurora is Denver's largest suburb and one of Colorado's most competitive markets. ListWorks PRO keeps agents compliant with Fair Housing scanning on every rewrite.",
    why_matters: "Aurora's diverse neighborhoods — from Centennial to Central Aurora — each have different buyer profiles. Generic copy fails here. Targeted, neighborhood-specific copy converts.",
    local_market: "Aurora has 3,000+ active listings across price points from $250K to $2M+. The Anschutz Medical Campus brings a steady stream of healthcare professional buyers year-round.",
    features: [
      { title: "Fair Housing Guard", desc: "Auto-scan for discriminatory language on every output." },
      { title: "Neighborhood-Specific Copy", desc: "Different angles for Central Aurora, Centennial, and Stapleton." },
      { title: "10-Second Rewrites", desc: "From draft to publish-ready in under 10 seconds." },
      { title: "5 Output Formats", desc: "MLS, social, email, and more from one input." },
    ],
  },
  {
    slug: "pueblo",
    city: "Pueblo",
    intro: "Pueblo is Southern Colorado's most affordable market — and it's attracting buyers priced out of Denver and Colorado Springs. ListWorks PRO helps agents capture that demand with better copy.",
    why_matters: "Pueblo agents are seeing an influx of remote workers and retirees who discovered the area during COVID. Your listings need to sell the lifestyle, not just the square footage.",
    local_market: "Pueblo's median home price is under $300K — the most affordable along the Front Range. Inventory is rising and buyers are comparing dozens of listings before making contact.",
    features: [
      { title: "Fair Housing Guard", desc: "Compliance on every output — discriminatory language caught automatically." },
      { title: "10-Second Rewrites", desc: "Fast copy for high-volume agents." },
      { title: "5 Output Formats", desc: "MLS, social, email, and more from one input." },
      { title: "AI Disclosure", desc: "Recommended best practice — add to any listing." },
    ],
  },
  {
    slug: "greeley",
    city: "Greeley",
    intro: "Greeley is Northern Colorado's hidden opportunity — affordable prices, University of Northern Colorado demand, and rapid growth. ListWorks PRO helps agents capitalize with professional AI listing copy.",
    why_matters: "Greeley buyers are value-conscious and comparing multiple markets. Your listing copy needs to highlight the value proposition without sounding like every other bargain pitch.",
    local_market: "Greeley's median price hovers around $400K with strong demand from first-time buyers and UNC-related relocations. Weld County growth is steady and agents are busy.",
    features: [
      { title: "Fair Housing Guard", desc: "Automatic compliance scan on every output — $26,262 HUD fines are real." },
      { title: "Value-Positioning Copy", desc: "Highlight price-per-sqft, neighborhood growth, and investment angle automatically." },
      { title: "10-Second Rewrites", desc: "High-volume agent? This is your tool." },
      { title: "5 Output Formats", desc: "MLS, social, email, and more from one input." },
    ],
  },
  // --- High-growth markets ---
  {
    slug: "boise",
    city: "Boise",
    intro: "Boise went from best-kept secret to top-10 growth market in three years. Your listing copy needs to keep pace. ListWorks PRO gives Treasure Valley agents AI-powered copy in 10 seconds.",
    why_matters: "Boise agents are competing against California buyers with cash offers and high expectations. Your copy needs to sell the Idaho lifestyle while standing up to out-of-state scrutiny.",
    local_market: "Ada County has seen 40% price appreciation since 2020. Competition among agents is intense and buyers are informed. Every listing gets compared side-by-side on Zillow.",
    features: [
      { title: "10-Second Rewrites", desc: "Fast copy for a fast-moving market." },
      { title: "Lifestyle Copy Engine", desc: "Auto-generates outdoor, quality-of-life, and value angles that resonate with relocating buyers." },
      { title: "Fair Housing Guard", desc: "Auto-scan every output for compliance." },
      { title: "5 Output Formats", desc: "MLS, Instagram, Facebook, headlines, buyer email." },
    ],
  },
  {
    slug: "salt-lake-city",
    city: "Salt Lake City",
    intro: "Salt Lake City is one of America's fastest-growing metros — and one of the most competitive for agents. ListWorks PRO keeps Wasatch Front agents ahead with instant AI listing copy.",
    why_matters: "SLC's tech corridor (Silicon Slopes) brings high-earning buyers with specific expectations. Generic copy doesn't close in a market where median income is rising fast.",
    local_market: "Salt Lake County averages 8,000+ active listings with DOM under 15 days in peak season. Tech company relocations from California continue to drive sustained demand.",
    features: [
      { title: "10-Second Rewrites", desc: "Publish-ready copy before the competition even starts." },
      { title: "Tech-Buyer Copy", desc: "Highlight walkability, home office potential, and proximity to Silicon Slopes employers." },
      { title: "Fair Housing Guard", desc: "Auto-compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email from one input." },
    ],
  },
  {
    slug: "bozeman",
    city: "Bozeman",
    intro: "Bozeman is now a luxury market with Montana prices. Remote-work migration and Big Sky proximity have transformed the market. ListWorks PRO helps agents tell that story compellingly.",
    why_matters: "Bozeman buyers are paying $700K+ for properties that were $300K in 2019. They want copy that justifies the price — lifestyle, access, investment — not square footage.",
    local_market: "Gallatin County is the fastest-growing county in Montana. MSU enrollment growth and Big Sky/Yellowstone proximity create year-round demand from multiple buyer profiles.",
    features: [
      { title: "Luxury Copy Engine", desc: "Lifestyle-first copy that matches the premium price point." },
      { title: "10-Second Rewrites", desc: "Instant copy for a market that moves fast." },
      { title: "Fair Housing Guard", desc: "Compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, Instagram, Facebook, headlines, buyer email." },
    ],
  },
  {
    slug: "sacramento",
    city: "Sacramento",
    intro: "Sacramento is California's new value play — and Bay Area buyers are paying attention. ListWorks PRO helps Sacramento agents convert remote-work buyers with copy that sells the lifestyle.",
    why_matters: "Sacramento agents are competing for Bay Area buyers who are skeptical of 'affordable California.' Your copy needs to sell the vision of what they get for the money.",
    local_market: "Sacramento metro has 12,000+ active listings with sustained demand from SF/Bay Area relocations. State government employment provides a stable year-round buyer base.",
    features: [
      { title: "10-Second Rewrites", desc: "Fast copy for high-volume agents." },
      { title: "Relocation Copy", desc: "Speak to Bay Area buyers: commute savings, space, lifestyle upgrade." },
      { title: "Fair Housing Guard", desc: "Automatic compliance screening." },
      { title: "5 Output Formats", desc: "MLS, social, email, and headlines." },
    ],
  },
  {
    slug: "san-francisco",
    city: "San Francisco",
    intro: "San Francisco real estate is the most scrutinized market in America. Buyers are sophisticated, agents are competitive, and copy that sounds generic gets ignored. ListWorks changes that.",
    why_matters: "SF buyers read every word. Vague phrases, clichés, and 'charming Victorian' descriptions are tuned out. You need specific, benefit-driven copy that earns a showing.",
    local_market: "San Francisco has 2,500+ active listings with prices from $800K to $10M+. Every micro-neighborhood — NOPA, Mission, Pacific Heights — has a different buyer profile.",
    features: [
      { title: "Anti-Cliché Engine", desc: "'Nestled,' 'charming,' and 'cozy' are banned. Every rewrite sounds fresh." },
      { title: "Micro-Neighborhood Copy", desc: "Different angles for different SF neighborhoods, automatically." },
      { title: "Fair Housing Guard", desc: "Critical in California — every output scanned." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines from one input." },
    ],
  },
  {
    slug: "washington-dc",
    city: "Washington DC",
    intro: "DC real estate is driven by government, tech, and international buyers. Your listing copy needs to work across all three audiences. ListWorks PRO handles it automatically.",
    why_matters: "DC agents compete across multiple jurisdictions — DC, Maryland, and Virginia. Each market has different buyer expectations and Fair Housing enforcement patterns.",
    local_market: "The DC metro area has 25,000+ active listings across DC, NoVA, and Maryland. Government hiring cycles create predictable seasonal demand that savvy agents capitalize on.",
    features: [
      { title: "Multi-Jurisdiction Copy", desc: "Tailored copy angles for DC, Maryland, and Virginia buyers." },
      { title: "Fair Housing Guard", desc: "DC has some of the strictest Fair Housing enforcement — compliance on every output." },
      { title: "10-Second Rewrites", desc: "From draft to publish-ready instantly." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "boston",
    city: "Boston",
    intro: "Boston's real estate market is defined by history, universities, and a buyer pool that has done their homework. ListWorks PRO helps agents write copy that matches the sophistication of the market.",
    why_matters: "Boston buyers are often educated professionals comparing multiple properties in competitive submarkets — Beacon Hill, South End, Back Bay, Cambridge. Generic copy doesn't work here.",
    local_market: "Greater Boston has 8,000+ active listings with a median price over $700K. Student-driven rental demand and biotech/pharma relocation keep multiple market segments active year-round.",
    features: [
      { title: "Neighborhood-Specific Copy", desc: "Beacon Hill vs. South End vs. Dorchester — different angles, automatically." },
      { title: "Fair Housing Guard", desc: "Massachusetts has strict enforcement — compliance on every output." },
      { title: "10-Second Rewrites", desc: "Fast copy for a competitive market." },
      { title: "5 Output Formats", desc: "MLS, Instagram, Facebook, headlines, buyer email." },
    ],
  },
  {
    slug: "philadelphia",
    city: "Philadelphia",
    intro: "Philadelphia is one of America's most undervalued markets — and buyers from NYC are discovering it fast. ListWorks PRO helps Philly agents convert curious out-of-towners into buyers.",
    why_matters: "Philly's row home and neighborhood character demand copy that tells a story, not just square footage. Buyers from NYC and DC are comparing 10+ listings before reaching out.",
    local_market: "Philadelphia has 12,000+ active listings with strong demand from first-time buyers and NYC relocators. Fishtown, Point Breeze, and Kensington are seeing significant appreciation.",
    features: [
      { title: "Story-Driven Copy", desc: "Neighborhood character and history angles that resonate with urban buyers." },
      { title: "Fair Housing Guard", desc: "Pennsylvania enforcement is active — auto-compliance on every output." },
      { title: "10-Second Rewrites", desc: "High-volume city market? This is built for you." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "minneapolis",
    city: "Minneapolis",
    intro: "Minneapolis is a tech hub, healthcare hub, and one of the Midwest's most competitive real estate markets. ListWorks PRO helps Twin Cities agents move listings faster with better copy.",
    why_matters: "Minneapolis buyers are data-driven and research-heavy. They've seen every listing on Zillow and Redfin before they call. Your copy needs to stand out in a sea of generic descriptions.",
    local_market: "Twin Cities metro has 15,000+ active listings. Minnesota's Fortune 500 concentration — Target, Best Buy, UnitedHealth — creates a steady stream of professional relocators.",
    features: [
      { title: "10-Second Rewrites", desc: "Publish-ready copy for a competitive market." },
      { title: "Professional Buyer Copy", desc: "Angles that resonate with corporate relocators and healthcare professionals." },
      { title: "Fair Housing Guard", desc: "Minnesota Fair Housing enforcement is strong — compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  // --- Florida expansion ---
  {
    slug: "fort-lauderdale",
    city: "Fort Lauderdale",
    intro: "Fort Lauderdale is South Florida's luxury waterfront capital. Your listings need copy that matches the price points — and ListWorks PRO delivers it in 10 seconds.",
    why_matters: "Fort Lauderdale agents compete for Northeast buyers and international investors who expect polished, specific copy. 'Updated kitchen' doesn't work when you're selling a $3M waterfront estate.",
    local_market: "Broward County has 20,000+ active listings with median prices climbing past $500K. The waterfront and ocean access segments command premium pricing that requires premium copy.",
    features: [
      { title: "Luxury Copy Engine", desc: "Waterfront, boating access, and lifestyle angles that match the premium market." },
      { title: "International Buyer Copy", desc: "Resonates with buyers from NY, NJ, CT, and international markets." },
      { title: "Fair Housing Guard", desc: "Florida enforcement — compliance auto-scanned on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines from one input." },
    ],
  },
  {
    slug: "sarasota",
    city: "Sarasota",
    intro: "Sarasota is Florida's arts and culture capital — and one of the most competitive luxury retirement markets in America. ListWorks PRO helps agents tell that story at scale.",
    why_matters: "Sarasota buyers are often downsizing from larger markets and have high standards for presentation. Your copy needs to sell the lifestyle — Siesta Key, the arts district, the food scene.",
    local_market: "Sarasota County has 8,000+ active listings with strong demand from Northern retirees and remote workers. The ultra-luxury segment ($3M+) has expanded significantly since 2020.",
    features: [
      { title: "Lifestyle-First Copy", desc: "Arts, beaches, and retirement lifestyle angles that convert Sarasota buyers." },
      { title: "Luxury Tone Options", desc: "Multiple writing styles from Modern to Luxury to Classic." },
      { title: "Fair Housing Guard", desc: "Auto-scan every output for compliance." },
      { title: "5 Output Formats", desc: "MLS, Instagram, Facebook, headlines, email." },
    ],
  },
  {
    slug: "naples",
    city: "Naples",
    intro: "Naples is America's most expensive real estate market outside New York and California. Your listing copy needs to match. ListWorks PRO generates luxury-tier copy in 10 seconds.",
    why_matters: "Naples buyers are high-net-worth individuals who compare properties across Florida, the Caribbean, and internationally. Your copy is competing at a global level.",
    local_market: "Collier County has 5,000+ active listings with a median price over $700K and an ultra-luxury segment topping $20M+. The market is driven by snowbirds, retirees, and Florida residents.",
    features: [
      { title: "Ultra-Luxury Copy", desc: "Prestige-tier copy that matches $2M+ listings." },
      { title: "Seasonal Buyer Copy", desc: "Angles that speak to snowbirds vs. full-time buyers vs. investors." },
      { title: "Fair Housing Guard", desc: "Compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "jacksonville",
    city: "Jacksonville",
    intro: "Jacksonville is Florida's largest city by area — and one of its fastest-growing real estate markets. ListWorks PRO helps Northeast Florida agents keep up with the pace.",
    why_matters: "Jacksonville attracts buyers from across Florida and the Southeast with its mix of affordability, beach access, and job growth. Generic copy gets buried in a market with 18,000+ listings.",
    local_market: "Duval County has 18,000+ active listings across price ranges from $200K to $3M+. Financial services and military (Naval Station Mayport) drive consistent year-round demand.",
    features: [
      { title: "10-Second Rewrites", desc: "High-volume market. Fast copy." },
      { title: "Beach Proximity Copy", desc: "Atlantic Beach, Neptune Beach, Ponte Vedra angles that convert coastal buyers." },
      { title: "Fair Housing Guard", desc: "Auto-compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "west-palm-beach",
    city: "West Palm Beach",
    intro: "Palm Beach County is South Florida's fastest-growing luxury market. ListWorks PRO helps agents from Boca to Jupiter compete with polished, professional listing copy.",
    why_matters: "The Palm Beach effect — driven by wealth migration from Northeast and Midwest — has elevated buyer expectations across the entire county. Budget listings and luxury listings both need better copy.",
    local_market: "Palm Beach County has 25,000+ active listings. The ultra-luxury segment ($10M+) in Palm Beach island is one of the most competitive in America.",
    features: [
      { title: "Multi-Tier Copy", desc: "From starter homes in Wellington to mansions in Palm Beach — the right tone for each." },
      { title: "Wealth-Migration Copy", desc: "Speak to NE/Midwest buyers: tax benefits, lifestyle upgrade, investment." },
      { title: "Fair Housing Guard", desc: "Auto-compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  // --- Texas expansion ---
  {
    slug: "fort-worth",
    city: "Fort Worth",
    intro: "Fort Worth is DFW's fastest-growing half — and it's developing its own distinct identity. ListWorks PRO helps Cowtown agents keep up with explosive demand.",
    why_matters: "Fort Worth buyers love the Texas authenticity angle. They're comparing Fort Worth to Frisco and McKinney. Your copy needs to sell the culture, not just the square footage.",
    local_market: "Tarrant County has 12,000+ active listings. Alliance corridor development and downtown revitalization are creating new buyer segments that didn't exist 5 years ago.",
    features: [
      { title: "Texas Lifestyle Copy", desc: "Authenticity, space, and value angles that resonate with Fort Worth buyers." },
      { title: "10-Second Rewrites", desc: "High-volume market. Fast copy." },
      { title: "Fair Housing Guard", desc: "Texas enforcement is active — auto-compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "san-antonio",
    city: "San Antonio",
    intro: "San Antonio is Texas's military and tourism capital — and one of its most affordable major markets. ListWorks PRO helps SA agents move listings faster with professional AI copy.",
    why_matters: "San Antonio's buyer pool is diverse: military families, retirees, first-time buyers, and relocating professionals. Generic copy misses each segment. ListWorks PRO targets all of them.",
    local_market: "Bexar County has 15,000+ active listings. Joint Base San Antonio (Lackland, Randolph, Fort Sam Houston) drives consistent relocation demand year-round.",
    features: [
      { title: "Military Relocation Copy", desc: "BAH-aware, school district-focused angles that convert military buyers." },
      { title: "10-Second Rewrites", desc: "High-volume market. Fast copy." },
      { title: "Fair Housing Guard", desc: "Auto-compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "plano",
    city: "Plano",
    intro: "Plano is DFW's corporate headquarters hub — and one of the most sought-after suburbs in America. ListWorks PRO helps Plano agents match the polished expectations of corporate buyers.",
    why_matters: "Plano buyers are corporate relocators from companies like Toyota, JPMorgan, and Capital One. They're comparing Plano to Frisco, Allen, and McKinney with spreadsheets. Your copy needs to win.",
    local_market: "Collin County has 10,000+ active listings with median prices above $550K. Corporate relocation packages drive buyers who make faster decisions — but only if the copy is credible.",
    features: [
      { title: "Corporate Relocation Copy", desc: "School district, commute time, and corporate campus proximity angles." },
      { title: "10-Second Rewrites", desc: "Instant professional copy for demanding buyers." },
      { title: "Fair Housing Guard", desc: "Auto-compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  // --- Arizona expansion ---
  {
    slug: "scottsdale",
    city: "Scottsdale",
    intro: "Scottsdale is America's luxury desert market — and it's booming. ListWorks PRO helps Scottsdale agents produce copy that matches $1M+ listings without spending hours on it.",
    why_matters: "Scottsdale buyers are comparing properties across Paradise Valley, Old Town, and North Scottsdale. They have high design expectations. Your copy needs to convey a lifestyle, not a floor plan.",
    local_market: "Maricopa County has 30,000+ active listings. The luxury segment in Scottsdale and Paradise Valley has strengthened significantly as California and New York buyers relocate to Arizona.",
    features: [
      { title: "Luxury Desert Copy", desc: "Mountain views, resort lifestyle, and Southwest design angles that convert." },
      { title: "Anti-Cliché Guard", desc: "'Stunning views' and 'entertainer's dream' are banned — every rewrite is fresh." },
      { title: "Fair Housing Guard", desc: "Arizona enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, Instagram, Facebook, headlines, email." },
    ],
  },
  {
    slug: "tempe",
    city: "Tempe",
    intro: "Tempe is Arizona State's backyard — and one of the most rental-to-purchase active markets in Arizona. ListWorks PRO helps Tempe agents speak to both investors and first-time buyers.",
    why_matters: "Tempe's buyer pool is uniquely young and investment-oriented. ASU proximity, light rail access, and tech employer presence create a distinct market that generic copy misses.",
    local_market: "Tempe has 2,000+ active listings with strong demand from ASU staff, tech employees (Intel, Microchip), and investors eyeing the university rental market.",
    features: [
      { title: "Investor Copy", desc: "Cap rate, rental income potential, and location angles for investment buyers." },
      { title: "First-Time Buyer Copy", desc: "Affordability, proximity, and lifestyle angles for young buyers." },
      { title: "Fair Housing Guard", desc: "Auto-compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  // --- Southeast expansion ---
  {
    slug: "charleston",
    city: "Charleston",
    intro: "Charleston is America's most charming city — and one of its hottest real estate markets. ListWorks PRO helps Lowcountry agents write copy as compelling as the city itself.",
    why_matters: "Charleston buyers move here for a reason: history, coast, food, culture. Your copy should sell that story, not square footage. ListWorks PRO automates it.",
    local_market: "Charleston metro has 8,000+ active listings. Intracoastal and historic district properties command premium pricing that requires premium copy. Remote work migration continues to fuel demand.",
    features: [
      { title: "Lifestyle Story Copy", desc: "Charleston culture, coastal access, and historic character angles." },
      { title: "Luxury Copy Engine", desc: "Matches the tone of $1M+ Lowcountry properties." },
      { title: "Fair Housing Guard", desc: "South Carolina enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, Instagram, Facebook, headlines, email." },
    ],
  },
  {
    slug: "savannah",
    city: "Savannah",
    intro: "Savannah is the South's most storied city — and its real estate market is having a moment. ListWorks PRO helps Savannah agents capture out-of-state buyers with copy that sells the experience.",
    why_matters: "Savannah's buyer pool is increasingly from the Northeast and Midwest, relocating for lifestyle and lower cost. Your copy needs to sell the Spanish moss, the squares, and the history — not the HOA.",
    local_market: "Chatham County has 3,000+ active listings. SCAD influence, downtown revitalization, and Hyundai's new plant are creating three distinct buyer pools that need different copy.",
    features: [
      { title: "Story-Driven Copy", desc: "Savannah's history and lifestyle woven into every listing description." },
      { title: "10-Second Rewrites", desc: "Fast copy for a growing market." },
      { title: "Fair Housing Guard", desc: "Georgia enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "birmingham",
    city: "Birmingham",
    intro: "Birmingham is the South's emerging tech hub — and its real estate market is waking up. ListWorks PRO helps Alabama agents stay ahead of the influx of remote workers discovering the Magic City.",
    why_matters: "Birmingham's affordability story is attracting buyers from Atlanta, Nashville, and Charlotte. They're comparing Birmingham to markets 3x the price. Your copy should make that comparison easy to win.",
    local_market: "Jefferson County has 6,000+ active listings with median prices under $300K — one of America's best price-to-income ratios for buyers. UAB and healthcare sector employment drive consistent demand.",
    features: [
      { title: "Value Positioning Copy", desc: "Price-to-quality angles that convert cost-conscious buyers from expensive markets." },
      { title: "10-Second Rewrites", desc: "Fast copy for high-volume agents." },
      { title: "Fair Housing Guard", desc: "Alabama enforcement — auto-compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "richmond",
    city: "Richmond",
    intro: "Richmond is Virginia's fastest-growing market — and Northern Virginia buyers are discovering it. ListWorks PRO helps RVA agents compete with polished, professional listing copy.",
    why_matters: "Richmond's buyer pool includes NoVA refugees escaping $700K starter homes. They have high expectations but a new value orientation. Your copy needs to sell both.",
    local_market: "Richmond metro has 6,000+ active listings. The Fan, Scott's Addition, and Northside neighborhoods are seeing particularly strong demand from young professionals.",
    features: [
      { title: "Urban Neighborhood Copy", desc: "The Fan, Scott's Addition, and Short Pump — different angles for each." },
      { title: "Value-Migration Copy", desc: "Speak to NoVA buyers: space, commute savings, lifestyle." },
      { title: "Fair Housing Guard", desc: "Virginia enforcement is active — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  // --- Midwest expansion ---
  {
    slug: "columbus",
    city: "Columbus",
    intro: "Columbus is America's fastest-growing major city by population — and its real estate market is the hottest in the Midwest. ListWorks PRO keeps Ohio agents competitive.",
    why_matters: "Columbus buyers are young, educated, and comparison-shopping across Short North, German Village, and suburban markets. Your copy needs to differentiate every listing.",
    local_market: "Franklin County has 8,000+ active listings. The Intel semiconductor plant and Ohio State University drive two massive, distinct buyer pools that both need targeted copy.",
    features: [
      { title: "10-Second Rewrites", desc: "Columbus moves fast. Your copy should too." },
      { title: "Neighborhood-Specific Copy", desc: "Short North vs. German Village vs. Dublin — different angles, automatically." },
      { title: "Fair Housing Guard", desc: "Ohio enforcement — auto-compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "indianapolis",
    city: "Indianapolis",
    intro: "Indianapolis is one of the most affordable major metros in America — and buyers are noticing. ListWorks PRO helps Indy agents capitalize on inbound migration with better copy.",
    why_matters: "Indianapolis attracts buyers from Chicago, Cincinnati, and Cleveland who want more house for their money. Your copy should make that value case with specificity, not generics.",
    local_market: "Marion County has 7,000+ active listings. Eli Lilly's global HQ expansion and the Salesforce Tower development are bringing corporate relocators with higher incomes and expectations.",
    features: [
      { title: "Value-Market Copy", desc: "Price-per-sqft and neighborhood-growth angles that convert comparison buyers." },
      { title: "Corporate Relocation Copy", desc: "Eli Lilly and Salesforce buyer angles built in." },
      { title: "Fair Housing Guard", desc: "Auto-compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "kansas-city",
    city: "Kansas City",
    intro: "Kansas City is America's most underrated real estate market — Chiefs dynasty included. ListWorks PRO helps KC agents write copy as compelling as the city's rebrand.",
    why_matters: "Kansas City is attracting buyers from Chicago, Dallas, and the coasts who've discovered the price-to-quality ratio. Your copy should make every listing feel like a discovery.",
    local_market: "Greater KC has 9,000+ active listings across Missouri and Kansas. The Country Club Plaza, Crossroads Arts District, and Leawood/Overland Park suburbs attract very different buyer profiles.",
    features: [
      { title: "Neighborhood Story Copy", desc: "Crossroads vs. Plaza vs. Leawood — different angles, automatically." },
      { title: "Discovery Framing", desc: "Copy that speaks to buyers who are 'finding' KC for the first time." },
      { title: "Fair Housing Guard", desc: "Missouri and Kansas enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "st-louis",
    city: "St. Louis",
    intro: "St. Louis is the Midwest's most affordable major city — and it's having a moment. ListWorks PRO helps St. Louis agents write copy that captures the emerging demand.",
    why_matters: "St. Louis buyers are getting younger and more urban. The Central West End and Lafayette Square renaissance is attracting buyers who wouldn't have considered St. Louis 5 years ago.",
    local_market: "St. Louis metro has 9,000+ active listings. Washington University and BJC Healthcare anchor two strong buyer pools. The suburb-to-urban shift is creating new neighborhoods of interest.",
    features: [
      { title: "Urban Renaissance Copy", desc: "Central West End, Lafayette Square, and downtown angles that sell the vision." },
      { title: "10-Second Rewrites", desc: "Fast copy for high-volume agents." },
      { title: "Fair Housing Guard", desc: "Missouri enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "omaha",
    city: "Omaha",
    intro: "Omaha is America's best-kept real estate secret — but Berkshire Hathaway homebuyers are starting to figure it out. ListWorks PRO helps Omaha agents compete with professional AI copy.",
    why_matters: "Omaha's Fortune 500 concentration per capita is one of the highest in America. Buyers are sophisticated, employed, and comparing properties on every platform.",
    local_market: "Douglas County has 3,500+ active listings with median prices that are among the most affordable in any major Midwest metro. Warren Buffett's hometown attracts serious long-term investors.",
    features: [
      { title: "10-Second Rewrites", desc: "Professional copy for a market that values substance." },
      { title: "Investment Copy", desc: "Long-term value and stability angles for the Omaha buyer profile." },
      { title: "Fair Housing Guard", desc: "Nebraska enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "milwaukee",
    city: "Milwaukee",
    intro: "Milwaukee is Wisconsin's largest city and its real estate market is gaining momentum. ListWorks PRO helps Milwaukee agents convert curious buyers with copy that sells the lake and the lifestyle.",
    why_matters: "Milwaukee's Lake Michigan waterfront and historic neighborhoods are drawing buyers from Chicago and Madison who are priced out. Your copy should close that gap.",
    local_market: "Milwaukee County has 4,000+ active listings. The Third Ward, Bay View, and Shorewood are seeing strong appreciation from Chicago refugee buyers seeking Lake Michigan access at half the price.",
    features: [
      { title: "Lakefront Copy", desc: "Lake Michigan access and shoreline lifestyle angles that convert Chicago buyers." },
      { title: "Value Migration Copy", desc: "Speak to Chicago buyers: half the price, same lake." },
      { title: "Fair Housing Guard", desc: "Wisconsin enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  // --- Pacific Northwest expansion ---
  {
    slug: "spokane",
    city: "Spokane",
    intro: "Spokane is Eastern Washington's emerging hub — affordable, growing, and attracting buyers priced out of Seattle and Portland. ListWorks PRO helps agents capitalize on the inbound wave.",
    why_matters: "Spokane buyers are relocating from Seattle with remote work and budget expectations that don't match the western WA market. Your copy needs to sell the Eastern WA lifestyle.",
    local_market: "Spokane County has 3,000+ active listings with median prices under $350K — roughly one-third of Seattle. Washington State University proximity and a growing tech scene are adding buyers.",
    features: [
      { title: "Value-Migration Copy", desc: "Sell the Eastern WA lifestyle to Seattle transplants." },
      { title: "10-Second Rewrites", desc: "Fast copy for a growing market." },
      { title: "Fair Housing Guard", desc: "Washington enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "tacoma",
    city: "Tacoma",
    intro: "Tacoma is Seattle's more affordable neighbor — and it's finally getting its due. ListWorks PRO helps Pierce County agents capture the wave of buyers discovering the South Sound.",
    why_matters: "Tacoma buyers are often Seattle workers who can't afford King County. They need copy that sells the commute trade-off by emphasizing lifestyle, space, and the Narrows views.",
    local_market: "Pierce County has 5,000+ active listings. Port of Tacoma and Joint Base Lewis-McChord (JBLM) create two massive, distinct buyer segments that require different copy approaches.",
    features: [
      { title: "Military Relocation Copy", desc: "JBLM-aware copy with school district and BAH angles." },
      { title: "Seattle Overflow Copy", desc: "Sell the South Sound to King County refugees: space, price, views." },
      { title: "Fair Housing Guard", desc: "Washington enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  // --- Northeast expansion ---
  {
    slug: "buffalo",
    city: "Buffalo",
    intro: "Buffalo is America's comeback city — and its real estate market is quietly one of the best values in the Northeast. ListWorks PRO helps Western New York agents write copy that converts.",
    why_matters: "Buffalo buyers from NYC and Boston are discovering that $300K here buys what $1.5M buys there. Your copy should make that value case with specificity and pride.",
    local_market: "Erie County has 3,500+ active listings at some of the lowest prices in any major Northeast market. The Buffalo Niagara Medical Campus is driving healthcare professional relocation at scale.",
    features: [
      { title: "Value Northeast Copy", desc: "Price-to-quality angles that convert NYC and Boston buyers." },
      { title: "Medical Campus Copy", desc: "BNMC proximity and healthcare professional buyer angles." },
      { title: "Fair Housing Guard", desc: "New York enforcement is among the strictest — auto-compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "hartford",
    city: "Hartford",
    intro: "Hartford is Connecticut's insurance capital — and its real estate market is benefiting from NYC overflow demand. ListWorks PRO helps CT agents capture hybrid workers fleeing high NYC prices.",
    why_matters: "Hartford buyers are often NYC commuters who've discovered they can work remote 3 days/week from a house, not an apartment. Your copy needs to sell the space and the commute math.",
    local_market: "Hartford County has 5,000+ active listings. Insurance sector employment (Aetna, Hartford Financial, CIGNA) provides a stable corporate buyer base year-round.",
    features: [
      { title: "NYC Overflow Copy", desc: "Commute, space, and value angles that convert hybrid workers." },
      { title: "Corporate Relocation Copy", desc: "Insurance sector and healthcare buyer angles." },
      { title: "Fair Housing Guard", desc: "Connecticut has strict Fair Housing laws — auto-compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "providence",
    city: "Providence",
    intro: "Providence is New England's creative hub — RISD, Brown, and a revitalized food scene make it one of the most appealing cities in the Northeast. ListWorks PRO helps RI agents sell that story.",
    why_matters: "Providence buyers are often young creative professionals from Boston and NYC who want urban living without urban pricing. Your copy should speak to that identity, not the square footage.",
    local_market: "Providence County has 2,500+ active listings. The college-town energy, waterfront development, and growing tech scene are creating a younger buyer demographic that expects authentic copy.",
    features: [
      { title: "Creative Culture Copy", desc: "RISD, college town, and arts district angles that convert creative buyers." },
      { title: "10-Second Rewrites", desc: "Fast copy for a growing market." },
      { title: "Fair Housing Guard", desc: "Rhode Island enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  // --- Mountain West ---
  {
    slug: "albuquerque",
    city: "Albuquerque",
    intro: "Albuquerque is New Mexico's largest city — and one of the most affordable markets in the West. ListWorks PRO helps ABQ agents compete with professional copy at every price point.",
    why_matters: "Albuquerque's buyer pool is diversifying rapidly: remote workers from CA and TX, Sandia Labs/Kirtland AFB employees, and first-time buyers. Each needs different copy.",
    local_market: "Bernalillo County has 3,000+ active listings. Sandia National Laboratories and Kirtland Air Force Base create a stable, well-educated buyer base with specific housing needs.",
    features: [
      { title: "Multi-Buyer Copy", desc: "Different angles for military, tech, and first-time buyers — automatically." },
      { title: "Desert Lifestyle Copy", desc: "Sandia Mountains, Old Town, and outdoor access angles." },
      { title: "Fair Housing Guard", desc: "New Mexico enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "reno",
    city: "Reno",
    intro: "Reno is Nevada's fastest-growing market — and the Bay Area tech exodus is accelerating it. ListWorks PRO helps Northern Nevada agents convert California buyers fast.",
    why_matters: "Reno buyers are often Bay Area transplants with tech salaries and remote work flexibility. They're comparing Reno to Lake Tahoe and Sacramento. Your copy should win that comparison.",
    local_market: "Washoe County has 3,000+ active listings. Tesla Gigafactory, Apple, and Amazon have established major operations in the Reno-Sparks metro, driving corporate relocation at scale.",
    features: [
      { title: "California Relocation Copy", desc: "No state income tax, space, and value angles that convert CA buyers." },
      { title: "Tech Employee Copy", desc: "Tesla, Apple, and Amazon buyer profiles built in." },
      { title: "Fair Housing Guard", desc: "Nevada enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  // --- Additional major markets ---
  {
    slug: "memphis",
    city: "Memphis",
    intro: "Memphis is America's most active investor market per capita — and ListWorks PRO helps Tennessee agents speak to both investors and owner-occupants with precision copy.",
    why_matters: "Memphis buyers come in two flavors: out-of-state investors chasing cap rates and local first-time buyers. Generic copy alienates both. ListWorks PRO targets each with the right angle.",
    local_market: "Shelby County has 7,000+ active listings with one of the highest investor purchase rates in America. FedEx World Hub employment and St. Jude Hospital provide a stable owner-occupant buyer base.",
    features: [
      { title: "Investor Copy", desc: "Cap rate, rental demand, and cash-flow angles that convert out-of-state investors." },
      { title: "Owner-Occupant Copy", desc: "School district, neighborhood, and lifestyle angles for local buyers." },
      { title: "Fair Housing Guard", desc: "Tennessee enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "louisville",
    city: "Louisville",
    intro: "Louisville is Kentucky's fastest-growing city — and its real estate market is one of the Midwest's best-kept secrets. ListWorks PRO helps Derby City agents write copy that converts.",
    why_matters: "Louisville's buyer pool is evolving: Nashville overflow, Chicago refugees, and in-state buyers discovering the Highlands and NuLu. Your copy should speak to all three.",
    local_market: "Jefferson County has 5,000+ active listings. UPS Worldport — one of the world's largest air hubs — provides year-round corporate relocation demand from logistics professionals.",
    features: [
      { title: "Neighborhood Character Copy", desc: "The Highlands, NuLu, and St. Matthews — different angles for each." },
      { title: "Corporate Relocation Copy", desc: "UPS, Humana, and healthcare sector buyer angles." },
      { title: "Fair Housing Guard", desc: "Kentucky enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "oklahoma-city",
    city: "Oklahoma City",
    intro: "Oklahoma City is one of America's most affordable major markets — and energy sector growth is making it one of the most dynamic. ListWorks PRO helps OKC agents write professional copy fast.",
    why_matters: "OKC buyers are a mix of energy industry professionals, military families (Tinker AFB), and first-time buyers. Each needs copy that speaks their language.",
    local_market: "Oklahoma County has 4,000+ active listings with median prices under $260K — among the lowest of any US major metro. Scissortail Park development is driving downtown appreciation.",
    features: [
      { title: "Value Market Copy", desc: "Price-per-sqft and affordability angles that resonate with OKC buyers." },
      { title: "Energy Sector Copy", desc: "Copy angles for oil and gas professional buyer profiles." },
      { title: "Fair Housing Guard", desc: "Oklahoma enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "tucson",
    city: "Tucson",
    intro: "Tucson is Arizona's college town turned retirement haven — and it's attracting buyers from Phoenix, California, and the Midwest. ListWorks PRO helps Pima County agents compete with polished copy.",
    why_matters: "Tucson buyers include University of Arizona families, retirees seeking desert living at half the Phoenix price, and remote workers from California. Each needs different copy.",
    local_market: "Pima County has 5,000+ active listings with median prices around $340K — significantly below Phoenix. Raytheon and defense contractor employment create a stable professional buyer base.",
    features: [
      { title: "Desert Lifestyle Copy", desc: "Saguaro, mountain views, and outdoor access angles that convert Tucson buyers." },
      { title: "Retirement Copy", desc: "Active adult and retirement lifestyle angles." },
      { title: "Fair Housing Guard", desc: "Arizona enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "pittsburgh",
    city: "Pittsburgh",
    intro: "Pittsburgh is America's most underrated city — and its real estate market is the best value in the Northeast. ListWorks PRO helps Steel City agents convert skeptical out-of-town buyers.",
    why_matters: "Pittsburgh buyers often need convincing. They've heard the reputation and not the reality. Your copy should lead with the hills, the rivers, the universities, and the price.",
    local_market: "Allegheny County has 5,000+ active listings with median prices under $250K. Carnegie Mellon and Pitt anchor a massive tech and healthcare buyer pool — Google, Apple, and Uber all have offices here.",
    features: [
      { title: "Discovery Copy", desc: "Sell Pittsburgh's reality to buyers who only know the reputation." },
      { title: "Tech Sector Copy", desc: "CMU, Google, and Uber buyer angles for Oakland and Shadyside." },
      { title: "Fair Housing Guard", desc: "Pennsylvania enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "cincinnati",
    city: "Cincinnati",
    intro: "Cincinnati is Ohio's most livable city — and buyers from Columbus, Chicago, and Louisville are discovering it. ListWorks PRO helps Queen City agents compete with professional AI copy.",
    why_matters: "Cincinnati's Over-the-Rhine renaissance and suburban growth are creating two distinct buyer markets. Your copy needs to match each neighborhood's character.",
    local_market: "Hamilton County has 5,000+ active listings. Procter & Gamble, Kroger, and Fifth Third Bank anchor a strong corporate buyer base. OTR renovation projects are creating new appreciation zones.",
    features: [
      { title: "Neighborhood Character Copy", desc: "OTR, Hyde Park, and Anderson Township — different angles for each." },
      { title: "Corporate Relocation Copy", desc: "P&G, Kroger, and healthcare sector buyer angles." },
      { title: "Fair Housing Guard", desc: "Ohio enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "ann-arbor",
    city: "Ann Arbor",
    intro: "Ann Arbor is Michigan's college town turned tech hub — and it's one of the most competitive small-city real estate markets in America. ListWorks PRO helps U of M area agents write copy that wins.",
    why_matters: "Ann Arbor buyers are educated, analytical, and comparing every listing with precision. Generic copy is the fastest way to get passed over in a market where buyers do real research.",
    local_market: "Washtenaw County has 2,000+ active listings with prices 40% above the Michigan average. University of Michigan faculty, Google, and automotive tech buyers create three premium buyer segments.",
    features: [
      { title: "Academic Buyer Copy", desc: "Faculty housing, walkability, and intellectual community angles." },
      { title: "Tech Sector Copy", desc: "Google and automotive tech buyer angles for downtown and neighborhoods." },
      { title: "Fair Housing Guard", desc: "Michigan enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "grand-rapids",
    city: "Grand Rapids",
    intro: "Grand Rapids is Michigan's second city and one of the Midwest's rising real estate stars. ListWorks PRO helps West Michigan agents stay competitive as the market heats up.",
    why_matters: "Grand Rapids buyers are often Detroit-area transplants or Chicago refugees who've discovered Michigan's west coast. Your copy should sell the beer scene, the lake, and the affordability.",
    local_market: "Kent County has 3,500+ active listings. Amway's corporate headquarters and a growing healthcare sector (Spectrum, Mercy Health) provide year-round corporate buyer demand.",
    features: [
      { title: "West Michigan Lifestyle Copy", desc: "Lake Michigan access, craft beer culture, and value-vs-Chicago angles." },
      { title: "10-Second Rewrites", desc: "Fast copy for a growing market." },
      { title: "Fair Housing Guard", desc: "Michigan enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "baltimore",
    city: "Baltimore",
    intro: "Baltimore is one of America's most complex real estate markets — block by block. ListWorks PRO helps Charm City agents write neighborhood-specific copy that converts at every price point.",
    why_matters: "Baltimore's hyper-local character demands copy that knows the difference between Fells Point, Canton, and Federal Hill. Generic copy doesn't work in a city where every block is different.",
    local_market: "Baltimore City and County have 10,000+ active listings. Johns Hopkins University and Hospital anchor a massive healthcare and academic buyer segment. DC overflow buyers are discovering Baltimore's value.",
    features: [
      { title: "Hyper-Local Copy", desc: "Fells Point vs. Canton vs. Hampden — different angles, automatically." },
      { title: "DC Overflow Copy", desc: "Sell the Baltimore-to-DC commute math to value-seeking DC buyers." },
      { title: "Fair Housing Guard", desc: "Maryland enforcement is active — auto-compliance on every output." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "new-orleans",
    city: "New Orleans",
    intro: "New Orleans is unlike any other city in America — and its real estate copy should be too. ListWorks PRO helps Louisiana agents write copy as unique as the neighborhoods they sell.",
    why_matters: "NOLA buyers aren't just buying a house — they're buying a lifestyle. The French Quarter, Uptown, Marigny, and Garden District each have a distinct culture that your copy should reflect.",
    local_market: "Orleans Parish has 4,000+ active listings. Tourism, Tulane/Loyola, and the Port of New Orleans create diverse buyer segments. Remote workers are discovering NOLA's quality-of-life-per-dollar.",
    features: [
      { title: "Neighborhood Culture Copy", desc: "French Quarter vs. Garden District vs. Marigny — distinct angles for each." },
      { title: "Lifestyle Story Copy", desc: "Culture, food, and architecture angles that no other city can match." },
      { title: "Fair Housing Guard", desc: "Louisiana enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "tulsa",
    city: "Tulsa",
    intro: "Tulsa is Oklahoma's second city — and it's been paying people $10,000 to move there for a reason. ListWorks PRO helps Green Country agents write copy that makes that case compellingly.",
    why_matters: "Tulsa Remote attracted thousands of professionals who discovered Oklahoma's quality of life. Your listing copy needs to close that discovery into a purchase.",
    local_market: "Tulsa County has 3,000+ active listings with median prices under $250K. The Gathering Place development and downtown revitalization have created new buyer interest in previously overlooked neighborhoods.",
    features: [
      { title: "Remote Worker Copy", desc: "Quality-of-life, space, and value angles that convert Tulsa Remote participants." },
      { title: "10-Second Rewrites", desc: "Fast copy for agents working both markets." },
      { title: "Fair Housing Guard", desc: "Oklahoma enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "madison",
    city: "Madison",
    intro: "Madison is Wisconsin's progressive college town — and its real estate market is one of the tightest in the Midwest. ListWorks PRO helps Dane County agents compete for the best listings.",
    why_matters: "Madison buyers are educated, deliberate, and comparing every listing with care. University of Wisconsin influence means analytical buyers who expect copy that earns their attention.",
    local_market: "Dane County has 2,500+ active listings with some of the lowest days-on-market in Wisconsin. Epic Systems and the university create two huge tech/academic buyer pools.",
    features: [
      { title: "Academic and Tech Buyer Copy", desc: "UW faculty, Epic employees, and startup founder buyer angles." },
      { title: "Progressive Lifestyle Copy", desc: "Walkability, bike lanes, and farmers market proximity angles." },
      { title: "Fair Housing Guard", desc: "Wisconsin enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
  {
    slug: "des-moines",
    city: "Des Moines",
    intro: "Des Moines is America's insurance capital — and one of the Midwest's best real estate values. ListWorks PRO helps Iowa agents write professional copy for a corporate-driven market.",
    why_matters: "Des Moines buyers are often corporate relocators from larger markets discovering Iowa's value. Your copy should sell the lifestyle upgrade at a fraction of the cost.",
    local_market: "Polk County has 4,000+ active listings. Principal Financial, Nationwide, and EMC Insurance anchor a strong corporate buyer base. The East Village and Gray's Lake areas are seeing strong appreciation.",
    features: [
      { title: "Value-Migration Copy", desc: "Price-per-sqft and lifestyle angles for buyers from larger metros." },
      { title: "Corporate Relocation Copy", desc: "Insurance sector buyer angles built in." },
      { title: "Fair Housing Guard", desc: "Iowa enforcement — auto-compliance." },
      { title: "5 Output Formats", desc: "MLS, social, email, headlines." },
    ],
  },
];

export default CITIES;
